import { Server, EyeOff, Clapperboard } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const BENEFITS = [
  {
    id: "freedom",
    icon: Clapperboard,
    title: "Свобода",
    text: "Любимые сериалы, музыка и AI-инструменты вроде ChatGPT и Midjourney — снова под рукой, даже там, где обычно закрыто.",
    highlight: true,
  },
  {
    id: "privacy",
    icon: EyeOff,
    title: "Приватность",
    text: "Никто не видит, что вы делаете в интернете: ни провайдер, ни кафе с вайфаем, ни сайты.",
  },
  {
    id: "access",
    icon: Server,
    title: "Для продвинутых",
    text: "Используйте кротика как клиент для своего сервера. В приложении есть дополнительные настройки для профессионалов.",
  },
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Chapter n="01">Зачем вам кротик</Chapter>
        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <Reveal
                key={b.id}
                delay={i * 0.12}
                className={b.highlight ? "md:col-span-2" : ""}
              >
                <div
                  data-testid={`benefit-card-${b.id}`}
                  className={`group h-full rounded-[2rem] border p-8 transition-transform duration-300 hover:-translate-y-2 sm:p-10 ${
                    b.highlight
                      ? "border-nora-mint/25 bg-nora-mint/10"
                      : "border-nora-ink/5 bg-nora-surface shadow-sm"
                  }`}
                >
                  <div
                    className={`mb-6 inline-flex rounded-2xl p-3.5 ${
                      b.highlight
                        ? "bg-nora-mint text-white"
                        : b.id === "privacy"
                          ? "bg-nora-pink/10 text-nora-pink"
                          : "bg-nora-accent/10 text-nora-accent"
                    }`}
                  >
                    <Icon className="h-7 w-7" />
                  </div>
                  <h3
                    className={`font-display font-bold tracking-tight ${
                      b.highlight
                        ? "text-2xl md:text-3xl"
                        : "text-xl md:text-2xl"
                    }`}
                  >
                    {b.title}
                  </h3>
                  <p
                    className={`mt-3 leading-relaxed text-nora-ink/70 ${
                      b.highlight ? "max-w-xl text-base md:text-lg" : "text-base"
                    }`}
                  >
                    {b.text}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
